import * as v from 'valibot';

import { type Entities, type Option, optionSchema } from './_core.model';

export const countryApiSchema = v.object({
  countryCallingCode: v.pipe(
    v.nullish(v.string()),
    v.transform((value) => value ?? ''),
  ),
  countryCode: v.string(),
  countryName: v.string(),
  postal: v.nullish(v.union([v.string(), v.null()])),
  postalCode: v.nullish(v.union([v.string(), v.null()])),
  presentationOrder: v.pipe(
    v.nullish(v.union([v.number(), v.string()])),
    v.transform((value) => (value == null ? 0 : Number(value))),
  ),
  stateCode: v.nullish(v.union([v.string(), v.null()])),
});

export const countriesApiSchema = v.array(countryApiSchema);

export type CountryApi = v.InferOutput<typeof countryApiSchema>;
export type CountriesApi = v.InferOutput<typeof countriesApiSchema>;

export const countrySchema = v.object({
  ...optionSchema.entries,
});

export type Country = Prettify<Option<v.InferOutput<typeof countrySchema>>>;

export type Countries = Entities<Country>;

export type CountryFilters = {
  search?: {
    countryCode?: string;
    countryName?: string;
  };
};
